export default vm
export const {
  Script,
  createContext,
  isContext,
  runInContext,
  runInDebugContext,
  runInNewContext,
  runInThisContext,
} = vm